import { v4 } from "uuid";

import { OfferDiscountLikeObject, OfferDto } from "@intelligems/ig-types";

import { DISCOUNT_MAX_UNITS } from "../../api/initials";

export const DiscountStub = (
  discountState: OfferDto
): OfferDiscountLikeObject => {
  const state = {
    ...discountState,
    offerProducts: [],
    id: v4(),
  };

  return {
    ...state,
    toModel: () => state,
  };
};

export const DiscountStateStub: OfferDto = {
  id: v4(),
  enabled: false,
  isTest: false,
  variationId: v4(),
  name: "Progress Bar Discount",
  unitType: "unit",
  discountType: "percentage",
  discountApplicationType: "",
  discountApplicationMethod: "perItem",
  shouldStack: false,
  shouldRejectCodes: false,
  tiers: [
    {
      id: v4(),
      minimumUnits: 0,
      maximumUnits: 1,
      unitDiscount: 0,
      discountTitle: null,
      isFreeShipping: false,
      isGiftWithPurchase: false,
      autoAddGiftWithPurchase: true,
    },
    {
      id: v4(),
      minimumUnits: 1,
      maximumUnits: 4,
      unitDiscount: 10,
      discountTitle: null,
      isFreeShipping: false,
      isGiftWithPurchase: false,
      autoAddGiftWithPurchase: true,
    },
    {
      id: v4(),
      minimumUnits: 4,
      maximumUnits: DISCOUNT_MAX_UNITS,
      unitDiscount: 15,
      discountTitle: null,
      isFreeShipping: false,
      isGiftWithPurchase: false,
      autoAddGiftWithPurchase: true,
    },
  ],
  isArchived: false,
  discountApp: null,
  maximumDollarDiscount: null,
};

export const TestShippingDiscountStateStub: OfferDto = {
  id: v4(),
  enabled: false,
  variationId: v4(),
  isTest: false,
  name: "Progress Bar Discount",
  unitType: "dollar",
  discountType: "percentage",
  discountApplicationType: "",
  discountApplicationMethod: "perItem",
  shouldStack: false,
  shouldRejectCodes: false,
  tiers: [
    {
      id: v4(),
      minimumUnits: 100,
      maximumUnits: DISCOUNT_MAX_UNITS,
      unitDiscount: 0,
      discountTitle: null,
      isFreeShipping: true,
      isGiftWithPurchase: false,
      autoAddGiftWithPurchase: true,
    },
  ],
  isArchived: false,
  discountApp: null,
  maximumDollarDiscount: null,
};

export const DiscountQuantityWidgetButtonsStub = [
  {
    id: v4(),
    quantity: 1,
    unitName: "units",
  },
  {
    id: v4(),
    quantity: 3,
    unitName: "units",
  },
  {
    id: v4(),
    quantity: 5,
    unitName: "units",
  },
];
